export default "__VITE_ASSET__GVf7yPwh__"